export default __webpack_public_path__ + "static/media/transaction-withdraw.2ffbaa74.svg";